import { render, staticRenderFns } from "./SearchFormItem.vue?vue&type=template&id=61e4bc48"
import script from "./SearchFormItem.vue?vue&type=script&lang=js"
export * from "./SearchFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports